<script setup>
import {computed, onMounted, ref} from "vue";
import {useDefaultsListStore} from "@/stores/defaultsListStore.js";
import {storeToRefs} from "pinia";
import CheckCircleIcon from "@/components/icons/CheckCircleIcon.vue";
import axios from 'axios'
const props = defineProps({
    total: {},
    totalTrees: {},
    url: {},
    users: {},
    project: {},
    closeProject: {},
    saveProject: {},
    filter: {},
    saving: {},
    hideLive: {default: false}
})

const defaultsListStore = useDefaultsListStore()
const {defaults,workTasks} = storeToRefs(defaultsListStore)

const step = ref(null)
const tasksArray = ref([])
const volunteers = ref([])
const nameReq = ref(false)

const groupedWorksTasks = computed(() => {
    if (!workTasks.value) {
        return [];
    }
    return groupBy(
        workTasks.value.filter(t =>
            t.display && [1, 2, 3, 4].includes(t.work_type_id)
        ),
        type => type.type
    );
})
const volunteersMapped = computed(() => {
    return volunteers.value.map(v => v.user);
})


onMounted(() => {
    nameReq.value = false;
    // emit("input", props.project);
    if (props.project.typeSelected === 7) {
        step.value = 3;
    } else {
        step.value = 1;
    }

    axios.get("/api/settings/volunteers").then(response => {
        if (response.data.volunteers) {
            volunteers.value = response.data.volunteers.users;
        }
    });
})

const saveProjectValidate = () => {
    if (!props.project.name || props.project.name === '') {
        nameReq.value = true;
    } else {
        nameReq.value = false;
        props.saveProject();
    }
}
const goTo = (type, targetStep) => {
    step.value = targetStep;
    props.project.typeSelected = type;
}
const toggleTaskToArray = (taskId) => {
    if (tasksArray.value.includes(taskId)) {
        tasksArray.value.splice(tasksArray.value.indexOf(taskId), 1);
    } else {
        tasksArray.value.push(taskId);
    }
    props.project.workTasks = tasksArray.value;
}
const groupBy = (array, fn) => {
    let result = {};
    array.forEach(item => {
        let key = fn(item);
        if (!result[key]) {
            result[key] = [];
        }
        result[key].push(item);
    });
    return result;
}

</script>
<template>
    <div
        style="max-height:95%"
        class="fixed top-0 z-10 inset-x-0 px-4 py-4 sm:inset-0 sm:flex sm:items-center sm:justify-center"
    >
        <div class="fixed inset-0 transition-opacity" style="z-index:-1">
            <div class="absolute inset-0 bg-slate-500 opacity-75"></div>
        </div>

        <div
            class="max-h-screen bg-white rounded-lg shadow-xl transform transition-all  sm:max-w-4xl sm:w-full lg:w-2/3 z-10 overflow-y-auto"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
        >
            <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                <div class="sm:flex sm:items-start">
                    <div
                        v-if="step === 1"
                        class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                    >
                        <h3
                            class="text-lg leading-6 font-medium text-slate-900"
                            id="modal-headline"
                        >
                            Create Project
                        </h3>
                        <div class="mt-2">
                            <p class="leading-5 text-slate-500">
                                Create a project from the filtered data.
                                Projects can be used for bulk works,
                                inspections, planting or stump removal.
                            </p>
                        </div>
                        <div class="mt-8 w-full">
                            <p
                                class="text-lg font-medium leading-5 text-slate-600"
                            >
                                Choose the type of Project
                            </p>
                        </div>
                        <div
                            class="w-full flex md:flex-nowrap flex-wrap justify-center text-center py-2"
                        >
                            <div
                                :class="
                                    filter.trees_status_id?.length === 0 ||
                                    filter.trees_status_id?.includes(2)
                                        ? 'opacity-100'
                                        : 'opacity-50'
                                "
                                class="w-full md:w-1/4 p-2 h-100"
                            >
                                <div
                                    @click.prevent="
                                        filter.trees_status_id?.length === 0 || filter.trees_status_id?.includes(2) ? goTo(3,2) : ''
                                    "
                                    class="rounded-lg border border-slate-200 h-full hover:shadow-lg cursor-pointer"
                                >
                                    <p
                                        class="text-lg py-2 text-orange-600 font-medium"
                                    >
                                        Works
                                    </p>
                                    <p class="text-sm px-2 pb-3 text-slate-500">
                                        Perform works on the filtered trees, if
                                        required.
                                    </p>
                                    <p
                                        v-if="
                                            filter.trees_status_id?.length > 0 &&
                                                !filter.trees_status_id?.includes(
                                                    2
                                                )
                                        "
                                        class="text-xs px-2 pb-3 pt-2 text-red-300"
                                    >
                                        Status must be changed.
                                    </p>
                                </div>
                            </div>
                            <div
                                :class="
                                    filter.trees_status_id?.length === 0 ||
                                    filter.trees_status_id?.includes(2)
                                        ? 'opacity-100'
                                        : 'opacity-50'
                                "
                                class="w-full md:w-1/4 p-2 h-100"
                            >
                                <div
                                    @click.prevent="
                                        filter.trees_status_id?.length === 0 ||
                                        filter.trees_status_id?.includes(2)
                                            ? goTo(7, 3)
                                            : '';
                                    "
                                    class="rounded-lg border border-slate-200 h-full hover:shadow-lg cursor-pointer"
                                >
                                    <p
                                        class="text-lg py-2 text-blue-600 font-medium"
                                    >
                                        Inspections
                                    </p>
                                    <p class="text-sm px-2 pb-3 text-slate-500">
                                        Perform Inspections on the filtered
                                        trees.
                                    </p>
                                    <p
                                        v-if="
                                            filter.trees_status_id?.length > 0 &&
                                                !filter.trees_status_id?.includes(
                                                    2
                                                )
                                        "
                                        class="text-xs px-2 pb-3 pt-2 text-red-300"
                                    >
                                        Status must be changed.
                                    </p>
                                </div>
                            </div>
                            <div
                                v-if="defaults.volunteers"
                                :class="
                                    filter.trees_status_id?.length === 0 ||
                                    filter.trees_status_id?.includes(2)
                                        ? 'opacity-100'
                                        : 'opacity-50'
                                "
                                class="w-full md:w-1/4 p-2 h-100"
                            >
                                <div
                                    @click.prevent="
                                        filter.trees_status_id?.length === 0 ||
                                        filter.trees_status_id?.includes(2)
                                            ? goTo(11, 3)
                                            : '';
                                    "
                                    class="rounded-lg border border-slate-200 h-full hover:shadow-lg cursor-pointer"
                                >
                                    <p
                                        class="text-lg py-2 text-purple-600 font-medium"
                                    >
                                        Volunteers
                                    </p>
                                    <p class="text-sm px-2 pb-3 text-slate-500">
                                        Create a protect to assign to
                                        volunteers.
                                    </p>
                                    <p
                                        v-if="
                                            filter.trees_status_id?.length > 0 &&
                                                !filter.trees_status_id?.includes(
                                                    2
                                                )
                                        "
                                        class="text-xs px-2 pb-3 pt-2 text-red-300"
                                    >
                                        Status must be changed.
                                    </p>
                                </div>
                            </div>
                            <div
                                :class="
                                    filter.trees_status_id?.length === 0 ||
                                    filter.trees_status_id?.includes(1)
                                        ? 'opacity-100'
                                        : 'opacity-50'
                                "
                                class="w-full md:w-1/4 p-2 h-100"
                            >
                                <div
                                    @click.prevent="
                                        filter.trees_status_id?.length === 0 ||
                                        filter.trees_status_id?.includes(1)
                                            ? goTo(8, 3)
                                            : '';
                                    "
                                    class="rounded-lg border border-slate-200 h-full hover:shadow-lg cursor-pointer"
                                >
                                    <p
                                        class="text-lg py-2 text-green-600 font-medium"
                                    >
                                        Planting
                                    </p>
                                    <p class="text-sm px-2 pb-3 text-slate-500">
                                        Plant these filtered trees, or locate
                                        planting locations.
                                    </p>
                                    <p
                                        v-if="
                                            filter.trees_status_id?.length > 0 &&
                                                !filter.trees_status_id?.includes(
                                                    1
                                                )
                                        "
                                        class="text-xs px-2 pb-3 pt-2 text-red-300"
                                    >
                                        Status must be changed.
                                    </p>
                                </div>
                            </div>
                            <div
                                :class="
                                    filter.trees_status_id?.length === 0 ||
                                    filter.trees_status_id?.includes(3)
                                        ? 'opacity-100'
                                        : 'opacity-50'
                                "
                                class="w-full md:w-1/4 p-2 h-100"
                            >
                                <div
                                    @click.prevent="
                                        filter.trees_status_id?.length === 0 ||
                                        filter.trees_status_id?.includes(3)
                                            ? goTo(9, 3)
                                            : '';
                                    "
                                    class="rounded-lg border border-slate-200 h-full hover:shadow-lg cursor-pointer"
                                >
                                    <p
                                        class="text-lg py-2 text-slate-600 font-medium"
                                    >
                                        Stumps
                                    </p>
                                    <p class="text-sm px-2 pb-3 text-slate-500">
                                        Create Project of the filtered stumps.
                                    </p>
                                    <p
                                        v-if="
                                            filter.trees_status_id?.length > 0 &&
                                                !filter.trees_status_id?.includes(
                                                    3
                                                )
                                        "
                                        class="text-xs px-2 pb-3 pt-2 text-red-300"
                                    >
                                        Status must be changed.
                                    </p>
                                </div>
                            </div>
                            <div
                                :class="
                                    filter.trees_status_id?.length === 0 ||
                                    filter.trees_status_id?.includes(2)
                                        ? 'opacity-100'
                                        : 'opacity-50'
                                "
                                class="w-full md:w-1/4 p-2 h-100"
                            >
                                <div
                                    @click.prevent="
                                        filter.trees_status_id?.length === 0 ||
                                        filter.trees_status_id?.includes(2)
                                            ? goTo(5, 3)
                                            : '';
                                    "
                                    class="rounded-lg border border-slate-200 h-full hover:shadow-lg cursor-pointer"
                                >
                                    <p
                                        class="text-lg py-2 text-blue-600 font-medium"
                                    >
                                        Watering
                                    </p>
                                    <p class="text-sm px-2 pb-3 text-slate-500">
                                        Create Watering Project on the filtered
                                        trees.
                                    </p>
                                    <p
                                        v-if="
                                            filter.trees_status_id?.length > 0 &&
                                                !filter.trees_status_id?.includes(
                                                    2
                                                )
                                        "
                                        class="text-xs px-2 pb-3 pt-2 text-red-300"
                                    >
                                        Status must be changed.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="step === 2"
                        class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                    >
                        <h3
                            class="text-lg leading-6 font-medium text-slate-900"
                            id="modal-headline"
                        >
                            Create a Works Project
                        </h3>
                        <div class="mt-2">
                            <p class="leading-5 text-slate-500 pb-2">
                                Determine the Works required. Select the works
                                you would like performed below:
                            </p>
                        </div>
                        <div
                            class="w-full flex flex-wrap lg:flex-nowrap justify-center text-center py-2"
                        >
                            <div
                                v-for="(tasks, type) in groupedWorksTasks"
                                :key="type"
                                class="w-full lg:w-1/3 px-1"
                            >
                                <p
                                    class="text-sm text-slate-700 font-semibold py-2"
                                >
                                    {{ type }}
                                </p>

                                <div
                                    v-for="task in tasks"
                                    :key="task.id"
                                    @click.prevent="toggleTaskToArray(task.id);"
                                    :class="
                                        tasksArray.includes(task.id)
                                            ? 'bg-green-200'
                                            : 'bg-slate-100'
                                    "
                                    class="w-full p-2 py-2 mb-2 items-center text-slate-700 leading-none lg:rounded-lg flex cursor-pointer"
                                    role="alert"
                                >
                                    <span
                                        class="flex rounded-full bg-slate-100 uppercase px-2 py-1 text-lg font-bold mr-3"
                                    >
                                        <span :class="
                                                tasksArray.includes(task.id)
                                                    ? 'visible'
                                                    : 'invisible'
                                            ">
                                            <CheckCircleIcon color="green" />
                                        </span>
                                    </span>
                                    <span
                                        class="font-semibold mr-2 text-left flex-auto"
                                    >{{ task.task }}</span
                                    >
                                </div>
                            </div>
                        </div>
                        <hr/>
                        <h3
                            class="text-lg leading-6 font-medium text-slate-900"
                            id="modal-headline"
                        >
                            Options
                        </h3>
                        <div class="mt-3 ml-1">
                            <div class="flex items-center">
                                <input
                                    v-model="project.canInspect"
                                    id="can_inspect"
                                    name="can_inspect"
                                    type="checkbox"
                                    class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-slate-300 rounded"
                                />
                                <label
                                    for="can_inspect"
                                    class="ml-2 block text-slate-500"
                                >
                                    Can also Inspect the Trees
                                </label>
                            </div>
                            <div class="flex items-center">
                                <input
                                    v-model="project.canVTA"
                                    id="can_vta"
                                    name="can_vta"
                                    type="checkbox"
                                    class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-slate-300 rounded"
                                />
                                <label
                                    for="can_vta"
                                    class="ml-2 block text-slate-500"
                                >
                                    Can undertake Visual Tree Assessment
                                </label>
                            </div>
                            <div class="flex items-center pl-8">
                                <input
                                    v-model="project.vtaRisk"
                                    :disabled="!project.canVTA"
                                    id="vta_risk"
                                    name="vta_risk"
                                    type="checkbox"
                                    class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-slate-300 rounded"
                                />
                                <label
                                    for="vta_risk"
                                    class="ml-2 block text-slate-500"
                                >
                                    Include Risk Assessment
                                </label>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="step === 3"
                        class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                    >
                        <h3
                            class="text-lg leading-6 font-medium text-slate-900"
                            id="modal-headline"
                        >
                            Project Details
                        </h3>
                        <div class="mt-2">
                            <p class="leading-5 text-slate-500">
                                Enter the Project Details below. This will be
                                shown to whoever you assign the Project to.
                            </p>
                        </div>
                        <div v-if="total && totalTrees" class="mt-4">
                            <p class="leading-5 text-slate-500">
                                <span class="font-bold">NOTE:</span> There are <span class="font-bold">{{ total }}</span> Works across <span class="font-bold">{{ totalTrees }}</span> trees. This Inspections Project will only show individual trees, stumps and removed trees.
                            </p>
                        </div>
                        <div
                            class="w-full flex flex-wrap justify-center text-center pt-8"
                        >
                            <div class="w-full md:flex md:items-center mb-6">
                                <div class="md:w-1/3">
                                    <label
                                        class="block text-slate-700 md:text-right mb-1 md:mb-0 pr-4"
                                        for="inline-full-name"
                                    >
                                        Project Name
                                    </label>
                                </div>
                                <div class="md:w-2/3">
                                    <input
                                        class="bg-slate-100 appearance-none border border-slate-400 rounded-lg w-full py-2 px-4 text-slate-700 leading-tight focus:outline-none focus:bg-white focus:border-slate-400"
                                        id="inline-full-name"
                                        type="text"
                                        required
                                        v-model="project.name"
                                    />
                                    <span v-if="nameReq"
                                          class="flex italic text-red-500 text-sm">Project Name Required</span>
                                </div>
                            </div>
                            <div class="w-full md:flex md:items-center mb-6">
                                <div class="md:w-1/3">
                                    <label
                                        class="block text-slate-700 md:text-right mb-1 md:mb-0 pr-4"
                                        for="inline-notes"
                                    >
                                        Project Notes
                                    </label>
                                </div>
                                <div class="md:w-2/3">
                                    <textarea
                                        class="bg-slate-100 appearance-none border border-slate-400 rounded-lg w-full py-2 px-4 text-slate-700 leading-tight focus:outline-none focus:bg-white focus:border-slate-400"
                                        id="inline-notes"
                                        rows="4"
                                        v-model="project.notes"
                                    ></textarea>
                                </div>
                            </div>

                            <div
                                v-if="
                                    [1, 5, 7, 8, 9].includes(
                                        props.project.typeSelected
                                    ) && !props.hideLive
                                "
                                class="w-full md:flex mb-6"
                            >
                                <div class="md:w-1/3">
                                    <label
                                        class="block text-slate-700 md:text-right mb-1 mt-2 md:mb-0 pr-4"
                                        for="live"
                                    >
                                        Live Project
                                    </label>
                                </div>

                                <div
                                    class="md:w-2/3 text-left border border-slate-300 bg-slate-100 rounded-lg py-2 px-4 text-slate-600"
                                >
                                    <input
                                        v-model="project.live"
                                        id="live"
                                        name="live"
                                        type="checkbox"
                                        class="h-5 w-5 mt-1 focus:ring-blue-500 border-slate-300 rounded"
                                    />
                                    <p v-if="props.project.typeSelected === 5" id="live-description" class="text-sm">
                                        If checked, this Project will reflect
                                        the current watering list <span class="font-bold italic">PLUS</span> any filters
                                        used that are listed below.
                                    </p>
                                    <p
                                        v-if="props.project.typeSelected === 5"
                                        class="text-sm"
                                    >
                                        <b
                                        >Filters for Live Watering Projects
                                            include:</b
                                        >
                                        Area, Suburb, Planted Date, Planted By, Tree Tags & Tree Type (e.g. Park or
                                        Street Tree).
                                    </p>
                                    <div
                                        v-if="props.project.typeSelected === 7 && !props.hideLive"
                                        class="text-sm"
                                    >
                                        <p>
                                            <b
                                            >Live Inspection Project:</b
                                            >
                                            A Live Inspection Project will display all the trees within the
                                            project area, plus allows users to add new trees or planting locations
                                            as well as remove trees. All actions are recorded in the project and can
                                            be exported to a CSV file.
                                        </p>
                                        <div class="flex items-center py-3">
                                            <div class="pr-2">
                                                <label
                                                    class="block text-slate-700 md:text-right mb-1 md:mb-0 pr-4"
                                                    for="inline-full-name"
                                                >
                                                    Estimated Duration (weeks)
                                                </label>
                                            </div>
                                            <div class="w-1/4">
                                                <input
                                                    class="bg-slate-100 appearance-none border border-slate-400 rounded-lg w-full py-2 px-4 text-slate-700 leading-tight focus:outline-none focus:bg-white focus:border-slate-400"
                                                    id="inline-full-name"
                                                    type="number"
                                                    increment="1"
                                                    v-model="project.weeksComplete"
                                                />
                                            </div>
                                        </div>

                                    </div>
                                    <p
                                        v-if="props.project.typeSelected === 8"
                                        class="text-sm"
                                    >
                                        <b
                                        >Filters for Live Planting Projects
                                            include:</b
                                        >
                                        Area, tree type, approval year,
                                        preferred species, location size,
                                        pavement removal req, pwerlines
                                        overhead, pot size & tags.
                                    </p>
                                    <p
                                        v-if="props.project.typeSelected === 9"
                                        class="text-sm"
                                    >
                                        <b
                                        >Filters for Live Stumps Projects
                                            include:</b
                                        >
                                        Area only.
                                    </p>

                                    <div
                                        v-if="
                                            project.typeSelected === 1 &&
                                                project.live
                                        "
                                        class="pt-3"
                                    >
                                        <div class="flex">
                                            <input
                                                class="bg-white appearance-none border border-slate-500 rounded-lg w-1/6 py-1 px-3 text-slate-700 leading-tight focus:outline-none focus:bg-white focus:border-slate-400"
                                                id="weeks-complete"
                                                type="number"
                                                v-model="project.weeksComplete"
                                            />
                                            <label
                                                for="weeks-complete"
                                                class="block text-sm md:text-right my-1 md:mb-0 pl-2 font-semibold italic"
                                            >
                                                Number Weeks for a tree to
                                                remain 'Complete'
                                            </label>
                                        </div>
                                        <p
                                            id="live-description"
                                            class="text-sm pt-1"
                                        >
                                            Trees will stay green for
                                            <b>{{ project.weeksComplete }}</b>
                                            weeks before turning back to grey.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="project.typeSelected == 11" class="w-full md:flex md:items-center mb-6">
                                <div class="md:w-1/3">
                                    <label
                                        class="block text-slate-700 md:text-right mb-1 mt-2 md:mb-0 pr-4"
                                        for="live"
                                    >
                                        Select Volunteers
                                    </label>
                                </div>
                                <div
                                    class="md:w-2/3"
                                >
                                    <!--                                    <multiselect-->
                                    <!--                                        v-model="project.selectedVolunteers"-->
                                    <!--                                        :options="volunteersMapped"-->
                                    <!--                                        placeholder="Select one or more"-->
                                    <!--                                        label="name"-->
                                    <!--                                        track-by="id"-->
                                    <!--                                        :searchable="true"-->
                                    <!--                                        :showLabels="true"-->
                                    <!--                                        :multiple="true"-->
                                    <!--                                    >-->
                                    <!--                                    </multiselect>-->
                                    <v-select
                                        :options="volunteersMapped"
                                        v-model="project.selectedVolunteers"
                                        label="name"
                                        searchable="true"
                                        :multiple="true"
                                    ></v-select>
                                </div>
                            </div>
                            <div v-if="project.typeSelected == 11" class="w-full mb-6">
                                <div class="w-full flex">
                                    <div class="md:w-1/3">
                                        <label class="block text-slate-700 md:text-right mb-1 mt-2 md:mb-0 pr-4">
                                        </label>

                                    </div>
                                    <div class="flex items-center md:w-2/3">
                                        <input
                                            v-model="project.include_photos"
                                            id="include_photos"
                                            name="include_photos"
                                            type="checkbox"
                                            class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-slate-300 rounded"
                                        />
                                        <label
                                            for="include_photos"
                                            class="ml-2 block text-slate-500"
                                        >
                                            Include Photos
                                        </label>
                                    </div>
                                </div>
                                <div class="w-full flex">
                                    <div class="md:w-1/3">
                                    </div>
                                    <div class="flex items-center md:w-2/3">
                                        <input
                                            v-model="project.include_notes"
                                            id="include_notes"
                                            name="include_notes"
                                            type="checkbox"
                                            class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-slate-300 rounded"
                                        />
                                        <label
                                            for="include_notes"
                                            class="ml-2 block text-slate-500"
                                        >
                                            Include Notes
                                        </label>
                                    </div>
                                </div>
                                <div class="w-full flex">
                                    <div class="md:w-1/3">
                                    </div>
                                    <div class="flex items-center md:w-2/3">
                                        <input
                                            v-model="project.include_tasks"
                                            id="include_tasks"
                                            name="include_tasks"
                                            type="checkbox"
                                            class="h-4 w-4 text-indigo-600 focus:ring-indigo-500 border-slate-300 rounded"
                                        />
                                        <label
                                            for="include_tasks"
                                            class="ml-2 block text-slate-500"
                                        >
                                            Include Tasks
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="bg-slate-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse"
            >
                <span
                    v-if="step === 2"
                    class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                >
                    <button
                        @click="step = 3;"
                        type="button"
                        class="inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Next
                    </button>
                </span>
                <span
                    v-if="step === 3"
                    class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto"
                >
                    <div
                        v-if="!saving"
                        @click="saveProjectValidate();"
                        class="inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-600 text-base leading-6 font-semibold text-white shadow-sm hover:bg-blue-500 focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 cursor-pointer"
                    >
                        Create Project
                    </div>
                    <button
                        v-else
                        type="button"
                        class="inline-flex justify-center w-full rounded-lg border border-transparent px-4 py-2 bg-blue-500 text-base leading-6 font-semibold text-white shadow-sm focus:outline-none focus:border-red-700 focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Creating... Please Wait
                    </button>
                </span>
                <span
                    v-if="step === 3 && tasksArray.length > 0"
                    class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                >
                    <button
                        @click="step = 2;"
                        type="button"
                        class="inline-flex justify-start w-full rounded-lg border border-slate-300 px-4 py-2 bg-slate-100 text-base leading-6 font-semibold text-slate-700 shadow-sm hover:text-slate-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Back
                    </button>
                </span>
                <span
                    v-else
                    class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto"
                >
                    <button
                        @click="
                            tasksArray = [];
                            closeProject();
                        "
                        type="button"
                        class="inline-flex justify-center w-full rounded-lg border border-slate-300 px-4 py-2 bg-slate-100 text-base leading-6 font-semibold text-slate-700 shadow-sm hover:text-slate-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5"
                    >
                        Cancel
                    </button>
                </span>
            </div>
        </div>
    </div>
</template>


<style lang="scss" scoped>
</style>
